export const ToggleButtonGroupWidgetId = 'ToggleButtonGroupWidget';

export enum ToggleButtonGroupWidgetAttributes {
  DISABLED = 'disabled',
  VALUE = 'value',
  ITEMS = 'items',
}
